
const serviceData = [
  {
    icon: 'ri-truck-line',
    title: 'Nationwide delivery',
    subtitle: 'Fast, tracked shipping across Pakistan.',
    bg: '#fdefe6',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Easy Returns',
    subtitle: 'Changed your mind? Send it back within 14 days.',
    bg: '#ceebe9',
  },
  {
    icon: 'ri-secure-payment-line',
    title: 'Secure Payment',
    subtitle: 'Protected checkout and verified payment options.',
    bg: '#e2f2b2',
  },
  {
    icon: 'ri-exchange-dollar-line',
    title: 'Real support',
    subtitle: 'Helpful people before, during and after your order.',
    bg: '#d6e5fb',
  },
]

export default serviceData
